import React, { useState } from 'react';

import {
  Button, Dialog, Box, Grid, makeStyles, DialogTitle, DialogContent,
  FormControl, Select, InputLabel,
  TextField
} from '@material-ui/core';

import { CircularProgress } from '@material-ui/core';
import { CustomToast, } from '@jumbo/components/custom/Toast';
import GridContainer from '@jumbo/components/GridContainer';
import { formatRut, LABEL_INPUT_FONT_SIZE, validateRut } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { TEXT_COLOR_FT } from 'config/config';
import { Save } from '@material-ui/icons';

const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));




const RepresentanteEditModal = props => {

  const {
    openDialog = false,
    close,
    dataCrear,
    fields,
    setDataCrear,
    postData,
    profesiones,

  } = props;

  const [loading, setIsLoading] = useState(false)
  const classes = addStyle()


  const onCloseDialog = (event, reason) => {

    if (reason !== 'backdropClick') {
      clearData()
      close();
    }

  };

  const clearData = () => {
    setIsLoading(false)
  }

  const addSpace = () => {
    setIsLoading(true)
    postData(dataCrear)
    onCloseDialog()
  }

  const validateMail = (mail) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(mail)
  }

  const validateEmptyField = (str) => {
    if (str) {
      return true
    } else {
      return false
    }
  }

  const validatePhoneLength = (str) => {
    if (str) {
      if (str.length !== 12) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  }

  const getModalContent = () => {
    return fields.map((campo, index) => {

      if (campo.type === 'text' || campo.type === 'number' || campo.type === 'phone' || campo.type === 'mail' || campo.type === 'rut') {

        switch (campo.type) {

          case 'rut': return <Grid key={index} item xs={6} sm={6}>
            <TextField
              label={campo.label}
              fullWidth
              error={
                !validateRut(dataCrear[campo.id])
              }
              size='small'
              variant='outlined'
              value={dataCrear[campo.id]}
              onChange={(e) => {
                let inputRut = e.target.value;
                inputRut = inputRut.slice(0, 13);
                const formattedRut = formatRut(inputRut);
                let aux = {
                  ...dataCrear,
                  [campo.id]: formattedRut
                }
                setDataCrear(aux)

              }}

            />
          </Grid>


          case 'text': if (campo.id === 'nombre_completo') {
            return null
          } else if (campo.id === 'direccion' && dataCrear['titulo'] !== 'Representante legal') {
            return null
          } else {
            return <Grid key={index} item xs={6} sm={6}>
              <TextField
                label={campo.label}
                fullWidth
                size='small'
                error={!validateEmptyField(dataCrear[campo.id])}
                variant='outlined'
                value={dataCrear[campo.id]}
                onChange={(e) => {
                  if (e.target.value.length < 100) {
                    let aux = {
                      ...dataCrear,
                      [campo.id]: e.target.value
                    }
                    setDataCrear(aux)
                  }
                }}

              />
            </Grid>
          }

          case 'number': return <Grid key={index} item xs={6} sm={6}>
            <TextField
              label={campo.label}
              fullWidth
              size='small'
              variant='outlined'
              error={!validateEmptyField(dataCrear[campo.id])}
              value={dataCrear[campo.id]}
              onChange={(e) => {
                const regex = /^[0-9]+$/;
                if (regex.test(e.target.value) || e.target.value === '') {
                  if (e.target.value.length < 12) {
                    let aux = {
                      ...dataCrear,
                      [campo.id]: e.target.value
                    }
                    setDataCrear(aux)
                  }
                }
              }}
            />
          </Grid>

          case 'mail': return <Grid key={index} item xs={6} sm={6}>
            <TextField
              label={campo.label}
              fullWidth
              error={!validateMail(dataCrear[campo.id])}
              size='small'
              variant='outlined'
              value={dataCrear[campo.id]}
              onChange={(e) => {
                if (e.target.value.length < 100) {
                  let aux = {
                    ...dataCrear,
                    [campo.id]: e.target.value
                  }
                  setDataCrear(aux)
                }
              }}
            />
          </Grid>

          case 'phone':
            return (
              <Grid key={index} item xs={6} sm={6}>
                <TextField
                  label={campo.label}
                  fullWidth
                  size='small'
                  error={!validatePhoneLength(dataCrear[campo.id])}
                  variant='outlined'
                  value={dataCrear[campo.id]}
                  onChange={(e) => {
                    let input = e.target.value;
                    if (!input.startsWith("+569")) {
                      input = '+569';
                    }
                    const regex = /^\+569([1-9][0-9]{0,7}|)$/;

                    if (regex.test(input)) {
                      if (input.length <= 13) {
                        setDataCrear({
                          ...dataCrear,
                          [campo.id]: input
                        });
                      }
                    }
                  }}
                />
              </Grid>
            );

          default: return <Grid key={index} item xs={6} sm={6}>
            <TextField
              label={campo.label}
              fullWidth
              size='small'
              variant='outlined'
              value={dataCrear[campo.id]}
              error={!validateEmptyField(dataCrear[campo.id])}
              onChange={(e) => {
                if (e.target.value.length < 100) {
                  let aux = {
                    ...dataCrear,
                    [campo.id]: e.target.value
                  }
                  setDataCrear(aux)
                }
              }}

            />
          </Grid>
        }


      } else if (campo.type === 'date') {

        return <Grid key={index} item xs={6} sm={6}>
          <TextField
            label={campo.label}
            fullWidth
            size='small'
            type="date"
            variant='outlined'
            value={dataCrear[campo.id]}
            error={!validateEmptyField(dataCrear[campo.id])}
            onChange={(e) => {
              let aux = {
                ...dataCrear,
                [campo.id]: e.target.value
              }
              setDataCrear(aux)
            }}
            InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
          />
        </Grid>

      } else if (campo.type === 'none') {
        return null
      } else {

        return <Grid key={index} item xs={6} sm={6}>
          <FormControl size='small' fullWidth>
            <InputLabel
              inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
              htmlFor="grouped-native-select"
              style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
              {campo.profesion}
            </InputLabel>
            <Select
              inputlabelprops={{ style: LABEL_INPUT_FONT_SIZE, shrink: true }}
              native
              id="grouped-native-select"
              error={!validateEmptyField(dataCrear[campo.id])}
              fullWidth
              variant='outlined'
              value={dataCrear[campo.id]}
              onChange={(e) => {

                let aux = {
                  ...dataCrear,
                  [campo.id]: e.target.value ? parseInt(e.target.value) : ''
                }
                setDataCrear(aux)
              }}

            >
              <option key={'0a'} value={''}> Seleccione </option>
              {optionsReturn(profesiones)}
            </Select>
          </FormControl>

        </Grid>


      }

    })
  }

  const optionsReturn = (arr) => {
    return arr.map((item, index) => {

      return <option key={index} value={item.id}> {item.profesion}</option>
    })
  }


  const validateForm = () => {

    const fieldsToValidate = Object.keys(dataCrear).filter(field => {
      if (field === 'rut') {
        return !validateRut(dataCrear[field])
      } else if (field === 'direccion') {

        if (dataCrear['titulo'] === 'Representante legal') {
          return dataCrear[field] === ''
        } else {
          return false
        }
      }
      else if (field === 'correo') {
        return !validateMail(dataCrear[field])
      } else if (field === 'telefono') {
        return !validatePhoneLength(dataCrear[field])
      } else {
        return dataCrear[field] === ''
      }
      //return true;
    });

    return !fieldsToValidate.every(field => dataCrear[field] === true);

  };


  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}>
        <Grid container justifyContent='space-between' style={{ color: TEXT_COLOR_FT }}>
          <Grid item >
            {'Editar  ' + dataCrear.titulo}
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <GridContainer>

            {

              getModalContent()

            }

          </GridContainer>
        </Box>

        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading} variant='outlined'>
            {"Cerrar"}
          </Button>
          <Box ml={2}>
            {<Button variant="outlined" color="primary" onClick={() => { addSpace() }} disabled={validateForm()}>
            <Save style={{ marginRight: 10 }} />
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Guardar'}
            </Button>
            }

          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RepresentanteEditModal;
